import { Click }                      from '../../../../click/click.class'
import { BetInterfaceSettingsButton } from './betInterface.button.settings.class'
import { BET_INTERFACE_BUTTONS }      from '../../../../../constants/betInterfaceButton/bet-interface-buttons.constant'

/**
 * @file Defines the {@link Cash} class.
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /** 
  * Class for handling cash button in bet interface
  * @extends BetInterfaceSettingsButton
  */
 export class Cash extends BetInterfaceSettingsButton {

    /**
     * Initlaise cash button
     */
    constructor() {
        super(BET_INTERFACE_BUTTONS.cash) //Call parent constructor
    }

    /** Adds click handler to cash button */
    add() {

        let cash = document.getElementById(BET_INTERFACE_BUTTONS.cash.id) //Retrieve cash button node
        new Click(cash, this.click, this)                                 //Add click handler
        this.added = true                                                 //Update click handler flag

    }

    /**
    * Click handler for cash button
    * @param {object} this_ - Reference to class's scope
    */
     click(this_) {

        //If game is displaying in coins
        if (balanceManager_.getShowIncredits()) {

            document.getElementById(BET_INTERFACE_BUTTONS.coins.id).classList.add('off') //Add button setting off styling to coins button
            this_.elem.classList.remove('off')                                           //Remove button setting off styling to cash button
            super.click()                                                                //Call super click

        }

     }

 }